import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { scenarioShowHurdleStore } from '../../storage/local/index';
import { CreateScenarioInvestment } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useCreateScenarioInvestment = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_INVESTMENTS,
  );

  const { mutate: createScenarioInvestment, isPending } = useAppMutation(
    [QueryKey.CREATE_SCENARIO_INVESTMENT],
    {
      mutationFn: ({ scenarioId, data }: { data: CreateScenarioInvestment; scenarioId: string }) =>
        ApiService.post(
          { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'investments'] },
          { body: data },
        ),
      onSuccess: () => {
        scenarioShowHurdleStore.delete();
        invalidateViewQueries();
      },
    },
  );
  return { createScenarioInvestment, isPending };
};
